<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper gameTimeline" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal gameTimeline" style="top: 0;">
				<div class="modalContent" ng-style="{minHeight: w.getOverlayHeightWithPadding(-10) || 'none'}">
					<div class="modalDecoration"></div>
					<div class="functionPanel unselectable">
						<a ng-if="w.params.modalParams.closeable" clickable="closeWindow('kingOrGovernor')" class="closeWindow clickable"  play-on-click="7" @click="onModalClose(close)">
							<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
								<i class="action_cancel_tiny_flat_black"></i>
								<!--<i class="closeWindow" :class="{'action_cancel_small_flat_black': !cancelHover, 'action_cancel_small_flat_green': cancelHover}" @mouseover="cancelHover = true" @mouseleave="cancelHover = false"></i>-->
							</div>
						</a>
					</div>
					<div class="contentHeader unselectable" ng-if="!w.contentHeaderTemplate">
						<h2 class="msAntiScroll">
							<span>Это только начало - узнай, что еще ждет тебя в Travian Kingdoms!</span>
						</h2>
					</div>
					<div class="heightTransitionContent">
						<div tabulation="" class="contentTabulation">
							<div class="tabulationContent scrollable tabContent scrollingDisabled">
								<div class="scrollContentOuterWrapper disableScrolling">
									<div class="scrollContent disableScrolling">
										<div class="scrollContentInnerWrapper">
											<div ng-transclude="">
												<div ng-controller="gameTimelineCtrl">
													<div class="stepCarousel">
														<div v-for="(step, index) in steps" class="stepContainer clickable" @click="selection.step = index" :class="{'selected': selection.step == index, 'stepHover': selection.hover == index, 'beforeSelected': selection.step > index, 'afterSelected': selection.step < index}" @mouseover="selection.hover = index" @mouseleave="selection.hover = -1">
															<div class="stepFrame">
																<div class="stepIllustration" :class="['timeline_'+step.illustration+'_illustration']"></div>
																<div class="contentBox gradient">
																	<h6 class="contentBoxHeader headerWithArrowEndings">
																		<div class="content">
																			<span>{{step.name}}</span>
																		</div>
																	</h6>
																	<div class="contentBoxBody">
																		<span>{{step.description}}</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<table class="stepTimeline transparent">
														<tbody>
															<tr>
																<td v-for="(step, index) in steps" @mouseover="selection.hover = index; selection.step = index;" @mouseleave="selection.hover = -1">
																	<div class="stepButtonContainer" :class="{'selected': selection.step == index, 'stepHover': selection.hover == index}">
																		<div class="stepButton"></div>
																	</div>
																	<i v-if="index == 0" class="feature_beginnersProtection_medium_illu" content="Защита новичка" v-tippy="{placement: 'top'}" tooltip-translate="KingOrGovernor.BeginnerProtection" tooltip-class="tooltipStyleBold" tooltip-placement="above"></i>
																</td>
															</tr>
															<tr>
																<td v-for="(step, index) in steps">
																	<span>{{step.tabname}}</span>
																	<!--
																	<span v-if="index == 0"><span>сегодня</span></span>
																	<span v-if="index == 1">1.<span>неделя</span></span>
																	<span v-if="index > 1">{{index}}.<span>месяц</span></span>
																	-->
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="window-overlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
		
		steps: [
			{
				tabname: 'сегодня',
				illustration: 'gameStart',
				name: 'Начало игры',
				description: 'Открой для себя мир Travian Kingdoms. Пусть этот путь приведет тебя к славе и могуществу!',
			},
			{
				tabname: '1.неделя',
				illustration: 'secondVillage',
				name: 'Вторая деревня',
				description: 'Построй вторую деревню и сделай еще один шаг к расширению границ своей империи.',
			},
			{
				tabname: '2.месяц',
				illustration: 'city',
				name: 'Первый город',
				description: 'Превращай свои деревни в могущественные города или расширяй свои владения множеством новых поселений.',
			},
			{
				tabname: '3.месяц',
				illustration: 'catapults',
				name: 'Катапульты и захват',
				description: 'Опасность таится за каждым углом - будь готов защитить свою империю!',
			},
			{
				tabname: '4.месяц',
				illustration: 'treasures',
				name: 'Война за сокровища',
				description: 'Ценные сокровища решат судьбу королевств и империй - защищай свои сокровища и отнимай их у других игроков!',
			},
			{
				tabname: '5.месяц',
				illustration: 'natars',
				name: 'Натары и чудеса света',
				description: 'Когда появится таинственное племя Натар и будут открыты чудеса света - захвати их, чтобы принести победу своему королевству.',
			},
			{
				tabname: '6.месяц',
				illustration: 'gameEnd',
				name: 'Конец игры',
				description: 'Только самые могущественные королевства смогут принять участие в финальном состязании за право первыми построить Чудо света и установить свое господство над миром Travian!',
			},
		],
		selection: {
			step: 0,
			hover: -1,
		},
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>